module.exports = __webpack_public_path__ + "static/tara-logo-blanc-en-16c4cdeb926fe4ee9e8817c611ead35b.svg";